import React from "react";
import { useNavigate } from "react-router-dom";

function Profile() {

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

const logout = () => {

  localStorage.removeItem("token");
  localStorage.removeItem("user");

  navigate("/", { replace: true });

  window.location.reload();
};

  if (!user) {
    return <h2>No user logged in</h2>;
  }

  return (

    <div style={{ padding: "40px" }}>

      <h1>User Profile</h1>

      <p><b>Employee ID:</b> {user.link_employee_id}</p>

      <p><b>Access Token:</b> {user.access_token}</p>

      <p><b>Working Branch:</b> {user.working_branch.branch_name}</p>

      <h3>User Roles</h3>

      <ul>
        {user.roles.map((role, index) => (
          <li key={index}>{role}</li>
        ))}
      </ul>

      <h3>Branches</h3>

      <ul>
        {user.branches.map((branch) => (
          <li key={branch.branch_id}>
            {branch.branch_name}
          </li>
        ))}
      </ul>

      <button onClick={logout}>Logout</button>

    </div>

  );

}

export default Profile;